export const getUserRole = (state) => state.userData.userRole;
